import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';

import { hasAdminAuth } from "api/commonUtil";
import BasicButton from "components/button/BasicButton";
import ProductAddModModal from "./ProductAddModModal";
import BranchOptionModModal from "./BranchOptionModModal";
import { delConfirm } from "js/common";

// 상품 목록
function ProductList() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이징 정보
	const [ pagingInfo, setPagingInfo ] = useState({});
	// 등록 팝업
	const [ isOpenAddModal, setIsOpenAddModal] = useState(false);
	// 수정 팝업
	const [ isOpenModModal, setIsOpenModModal] = useState(false);
	// 수정할 데이터
	const [ modInitData, setModInitData ] = useState({});
	// 지점 수정할 데이터
	const [ modBranchInitData, setModBranchInitData ] = useState({});
	// 지점 수정 팝업
	const [ isOpenBranchModal, setIsOpenBranchModal] = useState(false);

	//검색 조건
	const conditionList = [
		hasAdminAuth() ?
		{
			title : "상품 명",
			col : "productName",
			type : "input",
		} : null,
		hasAdminAuth() ?
		{
			title : "채널 상품 번호",
			col : "channelProductNo",
			type : "input",
		} : null,
		{
			title: "카테고리",
			col: "leafCategoryIdSff",
			type: "commonCodeSelect",
			grpCd: "LEAF_CATEGORY_SFF",
		},
		{
			title : "표시건수",
			col : "cntPerPage",
			type : "select",
			option: [
				{label: "10개씩보기", value: 10},
				{label: "20개씩보기", value: 20},
				{label: "50개씩보기", value: 50},
				{label: "100개씩보기", value: 100},
			],
		},
	];
	
	
	// 수정 팝업
	const modData = async (data) => {
		setModInitData({channelProductNo : data.channelProductNo});
		setIsOpenModModal(true);
	}

	// 지점 팝업
	const modBranch = async (data) => {
		setModBranchInitData({channelProductNo : data.channelProductNo});
		setIsOpenBranchModal(true);
	}

	const delData = async (d) => {
		if(!delConfirm()) {
			return;
		}

		const result = await sendDelete("/api/mgmt/product/" + d.channelProductNo);
		if(result.respCode === "SUCCESS") {
			alert("삭제 되었습니다.");
			searchList(condition);
		}


	}
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "채널 상품 번호", col : "channelProductNo", cellWidth: "100"},
		{ header : "원 상품 번호", col : "originProductNo", cellWidth : "100" },
		{ header : "상품명", col : "productName", cellWidth : "100" },
		{ header : "이미지", col : "imageUrl", type: "image", cellWidth : "100" },
		{ header : "카테고리", col : "leafCategoryNmSff", cellWidth : "100" },
		// { header : "등록일", col : "regDtStr", cellWidth : "50" },
		{ header : "수정", col : "originProductNo", cellWidth : "30", type : "modButton", onClick: modData},
		{ header : "지점", col : "originProductNo", cellWidth : "30", type : "modButton", onClick: modBranch, label: "관리"},
		{ header : "삭제", cellWidth : "30", type : "delButton", onClick: delData},
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			setInitialCondition({});
			searchList({});
		};

		initData();

	}, []);

	//목록 조회
	const searchList = async (cond = {}) => {
		let result = await sendGet("/api/mgmt/product", cond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			const dataList = result.data.list;
			dataList.forEach(data => {
				if(data.activationYn) {
					data.activationYnStr = "Y";
				} else {
					data.activationYnStr = "N";
				}
			});
			setDataList(result.data.list);
			setPagingInfo({...result.data, searchFnc : searchList, searchCond : cond});
		}
	}

	const addProduct = async (data) => {
		const result = await sendPost("/api/mgmt/product", data);
		if(result.respCode === "SUCCESS") {
			alert("등록되었습니다.");
			searchList(condition);
			setIsOpenAddModal(false);
		}
	}
	const modProduct = async (data) => {
		const result = await sendPut("/api/mgmt/product/" + data.channelProductNo, data);
		if(result.respCode === "SUCCESS") {
			alert("수정되었습니다.");
			searchList(condition);
			setIsOpenModModal(false);
		}
	}

	/*
	const modBranchOptions = async (data, delData) => {

		const sendData = {options: data};


		const result = await sendPost("/api/mgmt/product/branchOption/" + modBranchInitData.channelProductNo, sendData);
		// const result = await sendPut("/api/mgmt/product/branchOption/" + modBranchInitData.channelProductNo, sendData);
		if(result.respCode === "SUCCESS") {
			alert("요청하였습니다. 비동기 처리 이므로 처리 결과를 반드시 확인해 주세요.");
			// setIsOpenBranchModal(false);
		}
	}
		*/


	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
				<BasicButton
					label="추가"
					className="btn-add"
					onClick={() => setIsOpenAddModal(true)}
				/>
				{/* <BasicButton
					label="삭제"
					className="btn-del"
					disabled={selectedAdminList.length === 0}
					// selectRow={selectedAdminList}
					onClick={deleteAdmin}
				/> */}
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				rowClick={"checkbox"}
				pagingInfo={pagingInfo}
			/>
			{/* 상품 등록 */}
			<ProductAddModModal
				isOpen={isOpenAddModal}
				initData={{}}
				returnData={addProduct}
				onClose={()=> setIsOpenAddModal(false)}
				title="상품 등록"
			/>
			{/* 상품 수정 */}
			<ProductAddModModal
				isOpen={isOpenModModal}
				initData={modInitData}
				returnData={modProduct}
				onClose={()=> {setIsOpenModModal(false); setModInitData({});}}
				title="상품 수정"
			/>
			{/* 지점 옵션 */}
			<BranchOptionModModal
				isOpen={isOpenBranchModal}
				initData={modBranchInitData}
				// returnData={modBranchOptions}
				onClose={()=> {setIsOpenBranchModal(false); setModBranchInitData({});}}
				title="지점 옵션"
			/>

		</div>
	);
}

export default ProductList;